import { render } from "./Page404.vue?vue&type=template&id=604fcc06&scoped=true"
const script = {}

import "./Page404.vue?vue&type=style&index=0&id=604fcc06&scoped=true&lang=scss"

import exportComponent from "/var/www/html/devcwmserver.com/taca/client/staging/RACA_FRONTEND/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604fcc06"]])

export default __exports__